import IconShieldPerson from '@/shared/icons/NewDesign/IconShieldPerson'
import IconTune from '@/shared/icons/NewDesign/IconTune'
import IconBolt from '@/shared/icons/NewDesign/IconBolt'
import IconLocked from '@/shared/icons/NewDesign/IconLocked'
import IconCheckCircle from '@/shared/icons/NewDesign/IconCheckCircle'
import IconAlertCircle from '@/shared/icons/NewDesign/IconAlertCircle'

export const devToolsSections = [
  { key: 'contacts', labelKey: 'common.routes.contacts', Icon: IconShieldPerson },
  { key: 'pod-updater', labelKey: 'common.routes.pod_updater', Icon: IconBolt },
  { key: 'feedback', labelKey: 'common.routes.feedback', Icon: IconCheckCircle },
  { key: 'commands', labelKey: 'common.routes.commands', Icon: IconTune },
  { key: 'cache', labelKey: 'common.routes.cache', Icon: IconLocked },
  { key: 'communication', labelKey: 'common.routes.communication', Icon: IconAlertCircle },
]
